import React from 'react';
import { Toolbar, IconButton, Typography, Grid } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import GoogleLogin from "../LoginStatus";

const AppBarContent = ({ handleDrawerOpen, open }) => (
  <Toolbar>
    <IconButton
      color="inherit"
      aria-label="open drawer"
      onClick={handleDrawerOpen}
      edge="start"
      sx={{ mr: 2, ...(open && { display: 'none' }) }}
    >
      <MenuIcon />
    </IconButton>
    <Typography variant="h6" noWrap component="div">
      {''}
    </Typography>
    <Grid container justifyContent="flex-end">
      <Grid item>
        <GoogleLogin />
      </Grid>
    </Grid>
  </Toolbar>
);

export default AppBarContent;
